import React from 'react'
import styles from './index.module.less'
import { DownloadOutlined } from '@ant-design/icons'
import copy from 'copy-to-clipboard'
import { Tag, message } from 'antd'
const data = [
  { id: 1, title: 'iMFG2023会议资料', code: '666666', url: 'https://pan.baidu.com/download#win' },
  { id: 2, title: 'iMFG2022会议资料', code: '7777', url: 'https://pan.baidu.com/download#win' },
  { id: 3, title: 'iMFG2021会议资料', code: '6dd66', url: 'https://pan.baidu.com/download#win' },
  { id: 4, title: 'iMFG2020会议资料', code: '6afa666', url: 'https://pan.baidu.com/download#win' },
  { id: 5, title: 'iMFG2019会议资料', code: '6err66', url: 'https://pan.baidu.com/download#win' },
  { id: 6, title: 'iMFG2018会议资料', code: '6afd66', url: 'https://pan.baidu.com/download#win' },
  { id: 7, title: 'iMFG2017会议资料', code: '6wewe66', url: 'https://pan.baidu.com/download#win' },
  { id: 8, title: 'iMFG2016会议资料', code: '66as66', url: 'https://pan.baidu.com/download#win' },
  { id: 9, title: 'iMFG2023会议资料', code: '6ggg6', url: 'https://pan.baidu.com/download#win' },
  { id: 10, title: 'iMFG2023会议资料', code: 'ggg666', url: 'https://pan.baidu.com/download#win' },
  { id: 11, title: 'iMFG2023会议资料', code: 'aad666', url: 'https://pan.baidu.com/download#win' },
  { id: 12, title: 'iMFG2023会议资料', code: '6wewa6', url: 'https://pan.baidu.com/download#win' },
  { id: 13, title: 'iMFG2023会议资料', code: '6eee6', url: 'https://pan.baidu.com/download#win' },
  { id: 14, title: 'iMFG2023会议资料', code: '6eee66', url: 'https://pan.baidu.com/download#win' },
  { id: 15, title: 'iMFG2023会议资料', code: '6eee66', url: 'https://pan.baidu.com/download#win' },
  { id: 16, title: 'iMFG2023会议资料', code: 'eee66', url: 'https://pan.baidu.com/download#win' },
  { id: 17, title: 'iMFG2023会议资料', code: 'eee666', url: 'https://pan.baidu.com/download#win' },
]
export default function Download() {
  const download = (i) => {
    copy(i.code)
    message.success({
      content: '提取码复制成功，正在跳转...',
      duration: 2
    }).then(() => {
      window.open(i.url, '_blank')
    })
  }
  return (
    <div className={styles.box}>
      <span className={styles.big_title}>资料下载</span>
      <div className={styles.cont}>
        {
          data.map(i => (
            <div className={styles.link} key={i.id} onClick={() => { download(i) }}>
              <span>
                <span>{i.title}</span>
                <Tag color='red' className={styles.tag}>PPT</Tag>
              </span>
              <DownloadOutlined />
            </div>
          ))
        }
      </div>
    </div>
  )
}
